import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Input,
  message,
} from 'antd';
import { QUICK_PAY } from '../../../../../appconstants';

type Props = {
  payableAmount: String,
  setPayableAmount: Function,
  notes: String,
  setNotes: Function,
  setCurrentStep: Function,
  currencyType: String,
  buttonStyle: Object,
};

const SetAmountScreen = (props: Props) => {
  const {
    payableAmount,
    setPayableAmount,
    notes,
    setNotes,
    setCurrentStep,
    currencyType,
    buttonStyle,
  } = props;

  const [errorField, setErrorField] = useState({
    amount: null,
    notes: null,
  });

  const handlePayableAmount = (value) => {
    if (value === null
      || value === undefined
    ) {
      return;
    }
    if (value === '') {
      setPayableAmount('');
      return;
    }
    const regex = /^\d*(\.\d{0,2})?$/;
    if (regex.test(value)) {
      const parsedValue = parseFloat(value);
      if (!Number.isNaN(parsedValue)
        && parsedValue > QUICK_PAY.AMOUNT_MAX_LIMIT
      ) {
        message.error('Amount exceeds allowed limit');
        return;
      }
      setPayableAmount(value);
    }
  };

  const formatPayableAmount = (value) => {
    if (value === null || value === undefined) return;
    if (value === '') {
      setPayableAmount('');
      setErrorField(state => ({ ...state, amount: 'No Value' }));
      return;
    }
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      setErrorField(state => ({ ...state, amount: 'No Value' }));
      return;
    }
    if (parsedValue > QUICK_PAY.AMOUNT_MAX_LIMIT) {
      setErrorField(state => ({ ...state, amount: 'Amount exceeds allowed limit' }));
      return;
    }
    if (parsedValue < 1) {
      setErrorField(state => ({ ...state, amount: `The Amount can't be less than ${currencyType}1.00` }));
    } else {
      setErrorField(state => ({ ...state, amount: null }));
    }
    const floatFormattedValue = parsedValue.toString();
    const indexOfDecimalDot = floatFormattedValue.lastIndexOf('.');
    let formattedValue = indexOfDecimalDot !== -1 ? floatFormattedValue.slice(0, indexOfDecimalDot + 3) : floatFormattedValue;
    const [integralPart, decimalPart = ''] = formattedValue.split('.');
    formattedValue = `${integralPart}.${decimalPart.padEnd(2, '0')}`
    setPayableAmount(formattedValue);
  }; 

  const handleNotes = (value) => {
    if (!(typeof value === 'string')
      || value.length > 100
    ) return;
    setNotes(value.trim());
  };

  const handlePayButton = () => {
    if (errorField.amount !== null || errorField.notes !== null) {
      message.error(`Please resolve the errors`);
      return;
    }
    setCurrentStep(2);
  }

  return (
    <Col span={24}>
      <Row gutter={[300, 30]}>
        <Col span={24}>
          <h4 style={{ fontWeight: 'bold' }}>Enter Amount</h4>
          <Input
            prefix={currencyType}
            type="text"
            value={payableAmount}
            onChange={(e) => handlePayableAmount(e.target.value)}
            onBlur={(e) => formatPayableAmount(e.target.value)}
            style={{
              height: '50px',
              width: '100%',
            }}
          />
          <p>(Min Amount required {currencyType}1.00)</p>
          {errorField.amount && (
            <p style={{ color: 'red' }}>{errorField.amount}</p>
          )}
        </Col>
        <Col span={24}>
          <h4 style={{ fontWeight: 'bold' }}>Notes</h4>
          <Input
            type="text"
            value={notes}
            onChange={(e) => handleNotes(e.target.value)}
            style={{
              height: '50px',
              width: '100%',
            }}
          />
          <p>(max 100 characters)</p>
        </Col>
        <Col span={24}>
          <Button
            type="primary"
            shape="round"
            onClick={handlePayButton}
            style={{
              ...buttonStyle,
              height: '50px',
              width: '100%',
            }}
          >
            Pay
          </Button>
        </Col>
      </Row>
    </Col>
  );
};

export default SetAmountScreen;
